module.exports = __webpack_public_path__ + "img/RESTAURANTS.7403bca9.png";